export default defineNuxtRouteMiddleware(() => {
  const state = useState('opaqueToken')

  state.value = useCookie('opaqueToken').value
})
